import React from "react";
import { createRoot } from "react-dom/client";
import "@fontsource-variable/inter";
import "./index.css";
import "./typography.css";
import "./vcAnimations.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import SomethingWentWrong from "./containers/ErrorPage/WentWrong";
import { ErrorBoundary } from "react-error-boundary";

import App from "./containers/App";
import { Provider } from "react-redux";
import { ThemeContextProvider } from "./assets/theme/ThemeContextProvider";

// Date Pickers - migrated to shadcn/ui Calendar (react-day-picker)

import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file

import { registerServiceWorker } from "./serviceWorker";
import { installTranslationCrashGuard } from "./lib/translation-crash-guard";

// Define Redux Store
import { store } from "./redux/storeInstance";
import { ThemeProvider } from "./providers/theme-provider";
import { SessionProvider } from "./providers/session-provider";
import { ClarityProvider } from "./providers/clarity-provider";

// Must run before the first render so React never commits against a DOM a page
// translator has already reparented.
installTranslationCrashGuard();

const root = createRoot(document.getElementById("root"));
root.render(
  <ThemeProvider>
    <Provider store={store}>
      <React.StrictMode>
        <ErrorBoundary
          fallback={<SomethingWentWrong />}
          onError={(error, errorInfo) => {
            console.error("Caught error:", error, errorInfo);
          }}
        >
          <SessionProvider>
            <ClarityProvider>
              <ThemeContextProvider>
                <App />
              </ThemeContextProvider>
            </ClarityProvider>
          </SessionProvider>
        </ErrorBoundary>
      </React.StrictMode>
    </Provider>
  </ThemeProvider>,
);

registerServiceWorker();
